import React from 'react'

import Grid from '@material-ui/core/Grid'

import Point from 'components/Point'

interface VitalStatisticsRowProps {
  point: number
}

const VitalStatisticsRow: React.SFC<VitalStatisticsRowProps> = ({ point, children }) => (
  <Grid container justify="space-between" alignItems="center" direction="row" wrap="nowrap">
    <Grid item>
      {children}
    </Grid>
    <Grid item>
      <Point value={point} />
    </Grid>
  </Grid>
)

export default VitalStatisticsRow
